import { createSlice } from '@reduxjs/toolkit';

export const loadingSlice = createSlice({
    name: 'loading',
    initialState: { isLoading: false },
    reducers: {
        requestStarted(state) {
            state.isLoading = true;
        },
        requestFinished(state) {
            state.isLoading = false;
        },
    },
});
export const { requestStarted, requestFinished } = loadingSlice.actions;
const reducer = loadingSlice.reducer;
export default reducer;
